import React, { ReactNode, ReactNodeArray, CSSProperties } from 'react';
import Property from '@episerver/spa-core/Components/Property';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import EntityPaymentBlockData from '../../../Models/Content/EntityPaymentBlockData';
import EntityPayment from './EntityPayment';

export default class UpdateDeliverySlotBlock extends EpiComponent<EntityPaymentBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (
          <EntityPayment iContent={this.props.data}/>
      )
    }
}
